import { useDispatch, useSelector } from "react-redux";
import { serviceActions } from "../../store/service-Slice";
import { getEventsForGateway, getGroups, getSingleGateway, getSinglePadlock, getSinglePadlockEvents, getSiteAnalytics, updateGateway, updateLockDetails } from "../../Api Methods/Api";
import { Await, defer, useLoaderData, useNavigate } from "react-router-dom";
import Stats2 from "../../components/UI/Stats/Stats2";
import statClasses from "../Dashboard/Dashboard.module.css";
import classes from '../Padlocks/padlockEntity.module.css'
import { format } from "date-fns";
import { Suspense, useEffect, useRef, useState, useMemo } from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
import { Chart } from "react-chartjs-2";
import { MatrixController, MatrixElement } from "chartjs-chart-matrix";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import LogsTableLayout from "../../components/Table/LogsTableLayout";
import PadlockEvents from "../Padlocks/PadlockEvents";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import DataManager from "../../hooks/DataManager";
import GatewayEvents from "./gatewayEvents";
import Lottie from 'lottie-react';
import successAnim from '../../assets/animations/success.json';
import refreshBtn from "../../assets/portalAssets/refreshV2.png";

ChartJS.register(CategoryScale, LinearScale, Tooltip, Legend, MatrixController, MatrixElement);

const getBatteryColour = (value) => {
    if (value === null || value === undefined) return 'rgba(200, 200, 200, 0.3)';

    const v = Math.max(0, Math.min(100, value));

    const red = { r: 235, g: 14, b: 14 };
    const yellow = { r: 235, g: 218, b: 38 };
    const green = { r: 42, g: 204, b: 20 };

    let r, g, b;
    if (v <= 50) {
        const t = v / 50;
        r = Math.round(red.r + (yellow.r - red.r) * t);
        g = Math.round(red.g + (yellow.g - red.g) * t);
        b = Math.round(red.b + (yellow.b - red.b) * t);
    } else {
        const t = (v - 50) / 50;
        r = Math.round(yellow.r + (green.r - yellow.r) * t);
        g = Math.round(yellow.g + (green.g - yellow.g) * t);
        b = Math.round(yellow.b + (green.b - yellow.b) * t);
    }

    return `rgba(${r}, ${g}, ${b}, 0.8)`;
};

const HeatmapLegend = () => (
    <div style={{ display: "flex", gap: "18px", alignItems: "center", fontSize: "12px" }}>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px"}}>
            <p>0%</p>
            <div className={classes.gradient} />
            <p>100%</p>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <div style={{ width: 12, height: 12, borderRadius: 2, backgroundColor: "rgba(200, 200, 200, 0.5)" }} />
            <span>No data</span>
        </div>
    </div>
);

const HeatmapCard = ({ data, labels, isLoadingGwChart }) => {
    const hasData = data?.length > 0;
    const colourFn = getBatteryColour;

    const mainOptions = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: { bottom: 0, top: 0 }
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    title: () => '',
                    label: (context) => {
                        const item = context.dataset.data[context.dataIndex];
                        if (item.v === null) return `No data`;
                        return `${item.v}%`;
                    }
                }
            }
        },
        scales: {
            x: {
                type: 'category',
                position: 'top',
                labels: labels.dates,
                grid: { display: false },
                border: { display: false },
                ticks: { font: { size: 11 }, padding: 0 },
                afterFit: (axis) => { axis.paddingBottom = 15; }
            },
            y: {
                type: 'category',
                labels: labels.gateways,
                grid: { display: false },
                border: { display: false },
                ticks: { display: false },
                afterFit: (axis) => { axis.height = 30; }
            }
        }
    };

    const chartData = {
        datasets: [{
            data: data,
            backgroundColor(context) {
                const item = context.dataset.data[context.dataIndex];
                return colourFn(item?.v);
            },
            borderWidth: 0,
            width: ({ chart }) => (chart.chartArea || {}).width / labels.dates.length - 2,
            height: ({ chart }) => (chart.chartArea || {}).height / labels.gateways.length - 2
        }]
    };

    return (
        <div className={statClasses.chartCard} style={{ width: "100%", boxSizing: "border-box" }}>
                <>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                        <p className={statClasses.chartTitle} style={{ margin: 0 }}>Battery Levels - Last 14 Days</p>
                        <HeatmapLegend />
                    </div>
                    {isLoadingGwChart ? (
                        <div className={statClasses.skeletonBar} style={{ height: "55px", width: "100%" }} />
                    ) : (
                    !hasData ? (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "55px" }}>
                            <p style={{ textAlign: "center", color: "#888888", paddingBottom: "8px" }}>
                                No daily heartbeats in the last 14 days
                            </p>
                        </div>
                    ) : (
                        <div style={{ height: 55 }}>
                            <Chart type="matrix" data={chartData} options={mainOptions} />
                        </div>
                    )
                    )}
                </>
        </div>
    );
}


const GatewayEntity = () => {

    const { gateway } = useLoaderData();

    console.log(gateway);

    const [localGateway, setLocalGateway] = useState(gateway)
    const companyName = useSelector(state => state.auth.companyName);
    localStorage.removeItem('DeviceUUID')
    const isAllowed = companyName == "EyeSpyFX" ? true : false
    const isCustomerBillingAllowed = companyName === "EyeSpyFX" || companyName === "RE:SURE"
    const [unauthotisedClick, setUnauthorisedClick] = useState(false)

    const [gatewayEvents, setGatewayEvents] = useState([])
    const [showLoading, setShowLoading] = useState(true)
    const dispatch = useDispatch();
    const [groups, setGroups] = useState([])
    const token = localStorage?.getItem('token');
    const client = localStorage?.getItem('client');
    const apiDataRef = useRef({ token, client, companyName });
    apiDataRef.current = { token, client, companyName };
    const apiData = {
        token, 
        client
    }
    
    const [changeGatewayName, setChangeGatewayName] = useState(false)
    const [changeOwnedBy, setChangeOwnedBy] = useState(false)
    const [changeBillable, setChangeBillable] = useState(false)
    const [changeBilledTo, setChangeBilledTo] = useState(false)
    const [gatewayName, setNewGatewayName] = useState(localGateway.name)
    const [changeBillingFrequency, setChangeBillingFrequency] = useState(false)
    const [changeDateOfFirstInvoice, setChangeDateOfFirstInvoice] = useState(false)
    const [changeDateOfLastInvoice, setChangeDateOfLastInvoice] = useState(false)
    const [changePoweredBy, setChangePoweredBy] = useState(false)

    const [newOwnerGroupName, setNewOwnerGroupName] = useState(localGateway.ownedByGroupName || localGateway.owner)
    const [newBilledToGroupName, setNewBilledToGroupName] = useState(localGateway.billedToGroupName || localGateway.owner)
    const [changeCustomerBilledTo, setChangeCustomerBilledTo] = useState(false)
    const [newCustomerBilledToGroupName, setNewCustomerBilledToGroupName] = useState(localGateway.customerBilledToGroupName || "")
    const [showUpdateBilledToPrompt, setShowUpdateBilledToPrompt] = useState(false)
    const [pendingOwnerID, setPendingOwnerID] = useState(null)

    const [navigateToLinkedSite, setNavigateToLinkedSite] = useState(false)
    const [navigateToGroup, setNavigateToGroup] = useState(false)
    const [newBillingFrequency, setNewBillingFrequency] = useState("")
    const [newDateOfFirstInvoice, setNewDateOfFirstInvoice] = useState("")
    const [newDateOfLastInvoice, setNewDateOfLastInvoice] = useState("")
    const [newPoweredOption, setNewPoweredOption] = useState("")

    const [isLoadingGwChart, setIsLoadingGwChart] = useState(true);
    const [gwChartData, setGwChartData] = useState([]);

    const [userObject, setUserObject] = useState([])

    const toast = useRef(null);
    const navigate = useNavigate();

    const billingOptions = [
        "Monthly",
        "Annually"
    ]

    const lastRefreshTime = useRef(0);
    const cooldown = 8000;

    const now = new Date();
    const last14 = new Date();
    last14.setDate(now.getDate() - 14);

    const formatEventDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;
        const day = date.getDate();
        const month = date.getMonth() + 1;
        return `${day}/${month}`;
    };

    const convertGroupIDToName = (groupID) => {
        let group = groups.find(group => group.id == groupID)
        let groupName = ""
        if (group){
            groupName = group.name
        }
        return groupName
    }
    
    const ownedBy = localGateway.ownedByGroupName !== null ? localGateway.ownedByGroupName || localGateway.usedBy : "Unlinked"
    
    const GetGroups = async () => {
        const groups = await getGroups(apiData, dispatch)
        setGroups(groups)
    }

    const GetGatewayEvents = async () => {
        //const gatewayIMEI = gateway.IMEI.substring(11, 15)
        const response = await getEventsForGateway(apiData, gateway.IMEI)
        if (response.success){
            setGatewayEvents(response.data)
            setShowLoading(false)
        }
    }

    useEffect(() => {
        GetGatewayEvents();
        GetGroups();
        GetHeatmapData();
    }, [])

    

    useEffect(() => {
        if (navigateToLinkedSite){
            navigate(`/Dashboard/SiteView/${gateway.deviceUUID}`)
        }
    }, [navigateToLinkedSite])

    useEffect(() => {
        if (navigateToGroup){
            const groupClicked = groups.find(g => g.name === localGateway.usedBy);
            sessionStorage.setItem('groupClicked', groupClicked.name)   
            sessionStorage.setItem('groupPath', groupClicked.group_path)
            sessionStorage.setItem('groupClickedID', groupClicked.id)   
            navigate(`/Dashboard/Groups/GroupSites/`)
        }
    }, [navigateToGroup])

    const UpdateGatewayDetails = async (columnName, newValue) => {
        let body = {
            gatewayIMEI: gateway.IMEI,
            columnName: columnName,
            newValue: newValue
        }
        console.log(body);

        const response = await updateGateway(apiData, body, dispatch)
        console.log(response);
        if (response.success){
            setLocalGateway((prevGatewayObj) => ({
                ...prevGatewayObj,
                [columnName]: body.newValue,
            }));
        }
    }

    useEffect(() => {
        if (unauthotisedClick){
            toast.current.show({ severity: 'error', summary: 'Unauthorsied', detail: 'Please contact your administrator to update billing for this Gateway', life: 3000 });
            setUnauthorisedClick(false)
        }
    }, [unauthotisedClick])

    const accept = async () => {
        UpdateGatewayDetails("billable", localGateway.billable == 1 ? 0 : 1)    
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Billing status updated', life: 3000 });
    }

    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Cancelled', detail: 'Changes discarded', life: 3000 });
    }

    const GetHeatmapData = async () => {
        setIsLoadingGwChart(true);
        setGwChartData([]);
        const response = await getSiteAnalytics(apiDataRef.current, {
            siteUUID: "",
            groupName: apiDataRef.current.companyName || localStorage.getItem("companyName"),
            start_date: last14,
            end_date: now, 
            analyticsType: "gateways"
        }, dispatch);
        setGwChartData(response.data[0]);
        setIsLoadingGwChart(false);
    };

    const heatmapData = useMemo(() => {
        const allDates = [];
        for (let i = 13; i >= 0; i--) {
            const date = new Date();
            date.setDate(date.getDate() - i);
            allDates.push(date.toISOString().split('T')[0]);
        }
        const formattedDates = allDates.map(formatEventDate);

        if (!gwChartData || gwChartData.length === 0) {
            return { battery: [], labels: { dates: formattedDates, gateways: [] } };
        }

        const filteredData = gwChartData.filter(item => item.imei === localGateway.IMEI);

        if (filteredData.length === 0) {
            return { battery: [], labels: { dates: formattedDates, gateways: [] } };
        }

        const gatewayLabel = filteredData[0]?.tag || filteredData[0]?.key || 'Gateway';

        const batteryData = allDates.map(date => {
            const entry = filteredData.find(item => item.event_date === date);
            return {
                x: formatEventDate(date),
                y: gatewayLabel,
                v: entry?.battery ?? null
            };
        });

        return {
            battery: batteryData,
            labels: { dates: formattedDates, gateways: [gatewayLabel] }
        };
    }, [gwChartData, localGateway.IMEI]);

    const defaultConfirmProps = {
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Yes',
        rejectLabel: 'No',
        defaultFocus: 'accept',
        accept,
        reject,
    };

    const updateGatewayName = async () => {
        UpdateGatewayDetails("name", gatewayName)

        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Internal serial updated', life: 3000 });
        setChangeGatewayName(false)
    }   

    const updateOwnedBy = async () => {
        const newOwnerID = groups.find(g => g.name === newOwnerGroupName).id;
        UpdateGatewayDetails("ownedByGID", newOwnerID)
        setChangeOwnedBy(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            ownedByGroupName: newOwnerGroupName,
        }));

        setPendingOwnerID(newOwnerID)
        setShowUpdateBilledToPrompt(true)
    }

    const updateBilledTo = async () => {
        const newBilledToID = groups.find(g => g.name === newBilledToGroupName).id;
        UpdateGatewayDetails("billedToGID", newBilledToID)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Gateway subscription updated', life: 3000 });
        setChangeBilledTo(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            billedToGroupName: newBilledToGroupName,
        }));
    }

    const updateCustomerBilledTo = async () => {
        const newCustomerBilledToID = groups.find(g => g.name === newCustomerBilledToGroupName)?.id;
        if (!newCustomerBilledToID) return;
        UpdateGatewayDetails("customerBilledToGID", newCustomerBilledToID)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Customer billed to updated', life: 3000 });
        setChangeCustomerBilledTo(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            customerBilledToGroupName: newCustomerBilledToGroupName,
            customerBilledToGID: newCustomerBilledToID,
        }));
    }

    const updateBillingFrequency = async () => {
        UpdateGatewayDetails("billingFrequency", newBillingFrequency.toLowerCase())
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Billing frequency updated', life: 3000 });
        setChangeBillingFrequency(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            billingFrequency: newBillingFrequency,
        }));
    }

    const updateDateOfFirstInvoice = async () => {
        const formattedDate = newDateOfFirstInvoice ? format(newDateOfFirstInvoice, "yyyy-MM-dd") : ""
        UpdateGatewayDetails("firstInvoiceDate", formattedDate)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Invoice date updated', life: 3000 });
        setChangeDateOfFirstInvoice(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            firstInvoiceDate: formattedDate,
        }));
    }

    const updateDateOfLastInvoice = async () => {
        const formattedDate = newDateOfLastInvoice ? format(newDateOfLastInvoice, "yyyy-MM-dd") : ""
        UpdateGatewayDetails("lastInvoiceDate", formattedDate)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Invoice date updated', life: 3000 });
        setChangeDateOfLastInvoice(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            lastInvoiceDate: formattedDate,
        }));
    }

    const updatePoweredBy = async () => {
        UpdateGatewayDetails("poweredBy", newPoweredOption)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Gateway power source updated', life: 3000 });
        setChangePoweredBy(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            poweredBy: newPoweredOption,
        }));
    }

    const convertPowerOption = (poweredBy) => {
        switch (poweredBy) {
            case "solar" :
                return "Solar Panel"
            break;
            case "mains" : 
                return "Mains Powered"
            break;
            case "battery":
                return "Battery Only"
            break;
        }
    }

    const convertStatus = (status) => {
        let newStatus = status
        switch (status) {
            case "stale" : 
                newStatus = "Missed 2 Polls" 
            break;
            case "potentiallyStale" : 
                newStatus = "Missed 1 Poll" 
            break;
            case "online" :
                newStatus = "Online"
            break;
            case "offline" :
                newStatus = "Offline"
            break;
        }

        return newStatus;
    }

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                header="Set internal serial"
                visible={changeGatewayName}
                style={{ width: '50vw' }}
                onHide={() => { if (!changeGatewayName) return; setChangeGatewayName(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <InputText
                        value={gatewayName}
                        onChange={(e) => setNewGatewayName(e.target.value)}
                        style={{ width: '100%', fontSize: '1rem' }}
                    />

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeGatewayName(false)} className="p-button-secondary"/>
                        <Button  icon="pi pi-save" label="Save" onClick={updateGatewayName}/>
                    </div>
                </div>
            </Dialog>

            <ConfirmDialog
                    visible={changeBillable}
                    onHide={() => setChangeBillable(false)}
                    {...defaultConfirmProps}
                    message={`Are you sure you want to ${localGateway.billable == 0 ? 'start' : 'stop'} billing for this Gateway?`}
            />

            <Dialog
                header="Select new owner"
                visible={changeOwnedBy}
                style={{ width: '50vw', height:'20vw' }}
                onHide={() => { if (!changeOwnedBy) return; setChangeOwnedBy(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex:1201}}>
                    <Dropdown 
                        placeholder={newOwnerGroupName} 
                        options={groups.map((group) => group.name).sort((a, b) => a.localeCompare(b))}
                        onChange={(e) => setNewOwnerGroupName(e.value)}
                        filter
                        appendTo="self"
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeOwnedBy(false)} className="p-button-secondary"/>
                        <Button  icon="pi pi-save" label="Save" onClick={updateOwnedBy}/>
                    </div>
                </div>

            </Dialog>

            <Dialog
                header="Owner updated"
                visible={showUpdateBilledToPrompt}
                style={{ width: '35vw' }}
                onHide={() => setShowUpdateBilledToPrompt(false)}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Lottie
                        animationData={successAnim}
                        loop={false}
                        style={{ width: 150, height: 150 }}
                    />
                    <p style={{ color: '#6e6e6eff', textAlign: 'center' }}>Owner updated successfully. Would you also like to update Billed To?</p>
                    <br />
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <Button label="No" icon="pi pi-times" severity="secondary" onClick={() => setShowUpdateBilledToPrompt(false)} />
                        <Button label="Yes" icon="pi pi-check" severity="success" onClick={() => {
                            setNewBilledToGroupName(newOwnerGroupName)
                            UpdateGatewayDetails("billedToGID", pendingOwnerID)
                            setLocalGateway((prevGatewayObj) => ({
                                ...prevGatewayObj,
                                billedToGroupName: newOwnerGroupName,
                            }))
                            toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Billed To updated', life: 3000 })
                            setShowUpdateBilledToPrompt(false)
                        }} />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Select new purchasee"
                visible={changeBilledTo}
                style={{ width: '50vw', height:'35vw' }}
                onHide={() => { if (!changeBilledTo) return; setChangeBilledTo(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex:1201}}>
                    <Dropdown 
                        placeholder={newBilledToGroupName} 
                        options={groups.map((group) => group.name).sort((a, b) => a.localeCompare(b))}
                        onChange={(e) => setNewBilledToGroupName(e.value)}
                        filter
                        appendTo="self"
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeBilledTo(false)} className="p-button-secondary"/>
                        <Button  icon="pi pi-save" label="Save" onClick={updateBilledTo}/>
                    </div>
                </div>

            </Dialog>

            <Dialog
                header="Select customer billed to"
                visible={changeCustomerBilledTo}
                style={{ width: '50vw', height: '35vw' }}
                onHide={() => { if (!changeCustomerBilledTo) return; setChangeCustomerBilledTo(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex: 1201 }}>
                    <Dropdown
                        placeholder={newCustomerBilledToGroupName || "Select group"}
                        options={groups.map((group) => group.name).sort((a, b) => a.localeCompare(b))}
                        onChange={(e) => setNewCustomerBilledToGroupName(e.value)}
                        filter
                        appendTo="self"
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeCustomerBilledTo(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateCustomerBilledTo} />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Select new billing frequency"
                visible={changeBillingFrequency}
                style={{ width: '30vw', height:'20vw' }}
                onHide={() => { if (!changeBillingFrequency) return; setChangeBillingFrequency(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex:1201}}>
                    <Dropdown
                        placeholder={newBillingFrequency}
                        options={billingOptions}
                        onChange={(e) => setNewBillingFrequency(e.value)}/>
                </div>
                <br/>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                    <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeBillingFrequency(false)} className="p-button-secondary"/>
                    <Button  icon="pi pi-save" label="Save" onClick={updateBillingFrequency}/>
                </div>
            </Dialog>

            <Dialog
                header="Set date of hardware invoice"
                visible={changeDateOfFirstInvoice}
                style={{ width: '30vw' }}
                onHide={() => { if (!changeDateOfFirstInvoice) return; setChangeDateOfFirstInvoice(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Calendar
                        value={newDateOfFirstInvoice}
                        onChange={(e) => setNewDateOfFirstInvoice(e.value)}
                        dateFormat="dd/mm/yy"
                        showIcon
                        inline
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeDateOfFirstInvoice(false)} className="p-button-secondary"/>
                        <Button  icon="pi pi-save" label="Save" onClick={updateDateOfFirstInvoice} disabled={!newDateOfFirstInvoice}/>
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Set date of 1st SaaS invoice"
                visible={changeDateOfLastInvoice}
                style={{ width: '30vw' }}
                onHide={() => { if (!changeDateOfLastInvoice) return; setChangeDateOfLastInvoice(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Calendar
                        value={newDateOfLastInvoice}
                        onChange={(e) => setNewDateOfLastInvoice(e.value)}
                        dateFormat="dd/mm/yy"
                        showIcon
                        inline
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeDateOfLastInvoice(false)} className="p-button-secondary"/>
                        <Button  icon="pi pi-save" label="Save" onClick={updateDateOfLastInvoice} disabled={!newDateOfLastInvoice}/>
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Set power source"
                visible={changePoweredBy}
                style={{ width: '30vw' }}
                onHide={() => setChangePoweredBy(false)}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Button label="Mains powered" icon="pi pi-bolt" onClick={() => setNewPoweredOption("mains")} className={newPoweredOption === "mains" ? "" : "p-button-outlined"} />
                    <Button label="Solar panel" icon="pi pi-sun" onClick={() => setNewPoweredOption("solar")} className={newPoweredOption === "solar" ? "" : "p-button-outlined"} />
                    <Button label="Battery only" icon="pi pi-exclamation-circle" onClick={() => setNewPoweredOption("battery")} className={newPoweredOption === "battery" ? "" : "p-button-outlined"} />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangePoweredBy(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updatePoweredBy} disabled={!newPoweredOption} />
                    </div>
                </div>
            </Dialog>

            <div className={classes['activtyPage_container']}>
                <Await resolve={localGateway}>
                    {(loadedGateway) => (
                        <>
                        <div className={classes.container}>
                            <Stats2 title={"Gateway ID"} value={loadedGateway.IMEI} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Internal serial "} value={loadedGateway.name || "No name set"} isLoadingStats={false} isStatic={true} setChangeGatewayName={setChangeGatewayName} editable={true} />

                            {loadedGateway.usedBy && <Stats2 title={"Linked to"} value={loadedGateway.tag || loadedGateway.linkedSite} isLoadingStats={false} isStatic={true} setNavigateToLinkedSite={setNavigateToLinkedSite} /> }
                            {loadedGateway.dateLinked && <Stats2 title={"Date linked"} value={format(new Date(loadedGateway.dateLinked), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} /> }


                            <Stats2 title={"Registration date"} value={format(new Date(loadedGateway.dateAdded), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} />
                            {/* <Stats2 title={"Registered by"} value={loadedPadlock.registeredByName} isLoadingStats={false} isStatic={true} /> */}

                            <Stats2 title={"Last updated"} value={format(new Date(loadedGateway.lastSeenAt), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Battery"} value={loadedGateway.battery !== 0 ? `${loadedGateway.battery}%` : "Unknown"} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Powered by"} value={loadedGateway.poweredBy != "" ? `${convertPowerOption(loadedGateway.poweredBy)}` : "Unknown"} isLoadingStats={false} isStatic={true} setChangePoweredBy={setChangePoweredBy} editable={true} />
                            <Stats2 title={"Signal"} value={loadedGateway.signal !== 0 ? `${loadedGateway.signal > 100 ? 100 : loadedGateway.signal}%` : "Unknown"} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Network type"} value={loadedGateway.serviceType == 7 ? "NB-IOT" : (loadedGateway.serviceType ? `${loadedGateway.serviceType}` : "Unknown")} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Status"} value={convertStatus(loadedGateway.status)} isLoadingStats={false} isStatic={true} />

                            {loadedGateway.usedBy && <Stats2 title={"Used by"} value={loadedGateway.usedBy || "Unlinked"} isLoadingStats={false} isStatic={true} setNavigateToGroup={setNavigateToGroup}/>}
                            {<Stats2 title={"Owned by"} value={convertGroupIDToName(loadedGateway.ownedByGID)} isLoadingStats={false} isStatic={true} setChangeOwnedBy={setChangeOwnedBy} editable={isAllowed} />}
                            {isAllowed && <Stats2 title={"Billable"} value={loadedGateway.billable == 1 ? "Yes" : "No"} isLoadingStats={false} isStatic={true} setChangeBillable={setChangeBillable} isAllowedToChange={isAllowed} setUnauthorisedClick={setUnauthorisedClick} editable={isAllowed} />}
                            {(loadedGateway.billable == 1 && isAllowed) && <Stats2 title={"Inniovate bill to"} value={convertGroupIDToName(loadedGateway.billedToGID) || "Not set"} isLoadingStats={false} isStatic={true} setChangeBilledTo={setChangeBilledTo} isAllowedToChange={isAllowed} editable={isAllowed} />}

                            {/* Inniovate only */}
                            {isAllowed && <Stats2 title={"Billing frequency"} value={loadedGateway.billingFrequency != null ? loadedGateway.billingFrequency : "Not set"} isLoadingStats={false} isStatic={true} setChangeBillable={setChangeBillable} isAllowedToChange={isAllowed} setUnauthorisedClick={setUnauthorisedClick} setChangeBillingFrequency={setChangeBillingFrequency} editable={isAllowed} />}
                            {isAllowed && <Stats2 title={"Date of hardware invoice"} value={loadedGateway.firstInvoiceDate != null ? format(new Date(loadedGateway.firstInvoiceDate), "dd/MM/yyyy") : "Not set"} isLoadingStats={false} isStatic={true} setChangeBillable={setChangeBillable} isAllowedToChange={isAllowed} setUnauthorisedClick={setUnauthorisedClick} setChangeDateOfFirstInvoice={setChangeDateOfFirstInvoice} editable={isAllowed} />}
                            {isAllowed && <Stats2 title={"Date of 1st SaaS invoice"} value={loadedGateway.lastInvoiceDate != null ? format(new Date(loadedGateway.lastInvoiceDate), "dd/MM/yyyy") : "Not set"} isLoadingStats={false} isStatic={true} setChangeBillable={setChangeBillable} isAllowedToChange={isAllowed} setUnauthorisedClick={setUnauthorisedClick} setChangeDateOfFirstInvoice={setChangeDateOfFirstInvoice} setChangeDateOfLastInvoice={setChangeDateOfLastInvoice} editable={isAllowed} />}

                        </div>

                        {isCustomerBillingAllowed && <p style={{marginLeft:"2px", fontWeight:"500", fontSize:"20px", color:"#808080", marginBottom: "0px"}}>Customer billing</p>}
                        {isCustomerBillingAllowed &&
                          <div className={classes.container}>
                            <Stats2 title={"RE:SURE bill to"} value={convertGroupIDToName(loadedGateway.customerBilledToGID) || "No"} status={""} isLoadingStats={false} isStatic={true} setChangeBilledTo={setChangeCustomerBilledTo} isAllowedToChange={true} editable={true} />
                          </div>
                        }
                        <HeatmapCard data={heatmapData.battery} labels={heatmapData.labels} isLoadingGwChart={isLoadingGwChart}/>
                        </>
                    )}
                    
                </Await>
                    <p>Previous events (Max 100)</p>
                <Await resolve={gatewayEvents}>
                    {(loadedGatewayEvents) => {
                        return (
                            <>
                                <div style={{ display: "flex", width: "100%" }}>
                                    {showLoading ? (
                                        <div style={{ display: "flex", width: "100%" }}>
                                            <DeviceLoadingGrid
                                                CardCount={20} />
                                        </div>
                                    ) : (
                                        <GatewayEvents events={loadedGatewayEvents[0]} />
                                    )}
                                </div>
                            </>
                        )
                    }}
                </Await>
            </div>
        </>
    )
}

export default GatewayEntity;

export async function gatewayLoader({ params }) {
    const gatewayIMEI = params.GatewayIMEI;
    const token = localStorage?.getItem('token');
    const client = localStorage?.getItem('client');

    return { 
        gateway: await getSingleGateway({ token, client }, gatewayIMEI) };
}
